module.exports = __webpack_public_path__ + "static/media/protocolos.2f0acba9.jpg";